import { customChartKeyMap } from '@client/pages/activity-detail/config/sport.config';
import { CustomChartItems } from '@client/pages/activity-detail/config/chart-config';
import { isNoValue } from '@client/helper/validate';
import { CHART_TYPE_POINT } from '@client/pages/activity-detail/config/chart.types';
import { FREQUENCY_LIST, LAP_LIST, NULL_TEXT, getDataFrom, dealAttrDefine } from './common';
import definition from '@client/config/definition';

// topSummary 是顶级 summary， summary 可能是顶级也可能是子级 summary
export function getSportAttrs({ getFrom, chartAttr, topSummary, summary, graphObj }) {
  // TODO: todo_xjf sportList 变成 computed
  const Jump_Rope = CustomChartItems.Jump_Rope.find((i) => i.chartName === 'Speed');
  Jump_Rope.config = {
    graphObjKey: 'speed2',
    chartType: CHART_TYPE_POINT,
    valueKey: {
      [FREQUENCY_LIST]: 'speed2',
      [LAP_LIST]: 'avgSpeed'
    }[getFrom],
    tickText: (value, d) => {
      if (isNoValue(value)) {
        return NULL_TEXT;
      }
      return value;
    },
    unit: 'reps/min'
  };
  const { sportName } = summary;
  const isCustomSport = definition.isCustomSport(topSummary.sportType);
  if (isCustomSport) {
    const customSportKey = getCustomSportCharts(topSummary);
    CustomChartItems.Custom_Sport = customSportKey;
  }
  // 图表定义
  // console.log(`sportName`, sportName);
  const attrDefine = CustomChartItems[sportName];
  // console.log(`attrDefine`, attrDefine);
  if (!attrDefine) {
    return [];
  }
  const res = dealAttrDefine({ chartAttr, graphObj, attrDefine });
  return res;
}
export function getCustomSportCharts(summary) {
  const { customDataTypeList = [], customDataDsMultiplexList = [] } = summary;

  const arr = [];
  // dataType 判断9和10 是否同时存在
  let speedAndPaceCount = 0;
  // 过滤可支持字段
  customDataTypeList.forEach((dataType) => {
    if (dataType === 9 || dataType === 10) {
      speedAndPaceCount++;
    }
    const child = customChartKeyMap[dataType];
    if (child) {
      child.forEach((item) => {
        const { dsMultiplex } = item;
        if (dsMultiplex) {
          // 匹配复合条件
          if (customDataDsMultiplexList.includes(dsMultiplex)) arr.push(item);
        } else {
          arr.push(item);
        }
      });
    }
  });
  // 排序
  arr.sort((a, b) => {
    return a.order - b.order;
  });
  // 提取数据
  let charts = [];
  arr.forEach((item) => {
    if (speedAndPaceCount === 2 && item.dataType === 10) {
      // 判断9和10 是否同时存在, 跳过
    } else {
      item.chartName.forEach((chartName) => {
        charts.push({ chartName });
      });
    }
  });
  charts = Array.from(new Set(charts));
  return charts;
}
